// front-end/src/components/block-system/block-configs/block-types/news-block.js - ПРОСТАЯ ВЕРСИЯ

export function createNewsBlock(block, parent) {
    const blockName = block.data_block_name;

    // Определяем тип страницы и соответствующий стиль
    const isNewsFeedPage = window.location.pathname.match(/news-feed(\.html)?$/);
    const sectionType = parent.getAttribute('data-section');

    // Выбираем соответствующий класс контейнера
    const containerClass = isNewsFeedPage || sectionType === 'news-section-1'
        ? 'news-feed-item'
        : 'news-preview container-fluid';

    const newsItem = document.createElement('div');
    newsItem.className = containerClass;
    newsItem.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        newsItem.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        newsItem.setAttribute('data-order', String(block.order));
    } else {
        newsItem.setAttribute('data-order', '0');
    }

    newsItem.style.position = 'relative';

    const hasBlockId = block.id && block.id !== 'undefined';
    const newsStatus = block.news_status || 'draft';
    const isActiveLink = hasBlockId;
    const newsHref = isActiveLink ? (blockName && blockName.startsWith('case-') ? `/case/${blockName}` : `/news/${blockName}`) : '#';
    const dataPageAttr = isActiveLink ? `data-page="${blockName}"` : '';

    // ПРОСТОЕ РЕШЕНИЕ: Везде используем одинаковый data-content = ${blockName}-image
    if (isNewsFeedPage || sectionType === 'news-section-1') {
        // Разметка для news-feed.html
        newsItem.innerHTML = `
            <div class="news-feed-content">
                <div class="news-feed-upper">
                    <img class="news-feed-image" src="" alt="News Image" data-content="${blockName}-image" data-type="image" data-global="true">
                 <a href="${newsHref}" ${dataPageAttr} class="news-link ${isActiveLink ? 'active' : 'inactive'}">
                    <img src="images/news-button.svg" alt="news-button" class="news-button default">
                    <img src="images/news-button-hover.svg" alt="news-button-hover" class="news-button hover">
                 </a>

            </div>
                <div class="news-feed-info">
                    <h3 class="news-feed-title" data-content="${blockName}-title" data-global="true"></h3>
                    <p class="news-feed-description" data-content="${blockName}-description" data-type="textarea" data-global="true"></p>
                </div>
            </div>
            <div class="news-status-indicator status-${newsStatus}">
                <span class="status-text">${newsStatus.toUpperCase()}</span>
            </div>
        `;
    } else {
        // Разметка для главной страницы - тоже добавим изображение!
        newsItem.innerHTML = `
            <div class="row">
                <div class="col-lg-6 news-preview-meta">
                    <p class="publication-date" data-content="${blockName}-date" data-global="true" data-type="date"></p>
                    <img src="" alt="News Image" data-content="${blockName}-image" data-type="image" data-global="true" style="width: 100%; max-width: 300px; height: auto; border-radius: 8px; margin-top: 10px;">
                </div>
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-10">
                            <h5 data-content="${blockName}-title" data-global="true"></h5>
                            <p data-content="${blockName}-description" data-type="textarea" data-global="true"></p>
                        </div>
                        <div class="col-lg-2">
                            <a href="${newsHref}" ${dataPageAttr} class="news-link ${isActiveLink ? 'active' : 'inactive'}">
                                <img src="images/news-button.svg" alt="news-button" class="news-button default">
                                <img src="images/news-button-hover.svg" alt="news-button-hover" class="news-button hover">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="news-status-indicator status-${newsStatus}">
                <span class="status-text">${newsStatus.toUpperCase()}</span>
            </div>
        `;
    }

    parent.appendChild(newsItem);
    return newsItem;
}

export const newsBlockProps = {
    name: 'news-block',
    title: 'Новостной блок',
    description: 'Блок для отображения новости с датой, заголовком и описанием',
    allowedParents: ['news-section', 'news-section-1'],
    contentFields: [
        {name: 'date', type: 'date', label: 'Дата публикации'},
        {name: 'title', type: 'text', label: 'Заголовок'},
        {name: 'description', type: 'textarea', label: 'Описание'},
        {name: 'image', type: 'image', label: 'Изображение новости'}
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview news-block-preview">
                <div class="row">
                    <div class="col-6">
                        <p class="date">${data.date || 'Дата'}</p>
                        <div class="image-placeholder" style="width: 100px; height: 60px; background: #eee; border-radius: 4px;"></div>
                    </div>
                    <div class="col-6">
                        <h5>${data.title || 'Заголовок новости'}</h5>
                        <p>${data.description || 'Описание новости...'}</p>
                    </div>
                </div>
            </div>
        `;
    }
};